import { DescriptionText, FlexContainer, Img } from "../../design";
import React, { useState, useEffect } from "react";
import { CheckCircleFilled, MinusCircleOutlined } from '@ant-design/icons';
import { Collapse } from "antd";
import VISA from "../../assets/imgs/VISA.svg";
import DISCOVER from "../../assets/imgs/DISCOVER.svg";
import MASTER from "../../assets/imgs/MASTER_CARD.svg";
import SWIREPAY_FULL_LOGO from "../../assets/imgs/swirepay-logo.svg";
import AMEX from "../../assets/imgs/amex-icon.svg";
import INSTANT_PAYMENT_IMG from "../../assets/imgs/INSTANT_PAYMENT.svg";
import { Button } from "antd";
import { paymentMethodsHelper, omitOtherPayments, bankPaymentMethods } from "./Components/helper";
import { useDispatch } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";

type Props = {
  tabs: Array,
  tabPanels: Array,
  onSelect: Function,
  defaultSelectedTab: number,
  name: string,
  mode: String,
  paymentTypes: string,
  tabName: string,
  upiDown: Boolean,
  interval: String,
  accountGid: String,
  getCurrentTab: Function,
  setUpdated: Function,
};

const getCheckedIcons = (value) => {
  return value ? <CheckCircleFilled style={{ color: "#34A853", fontSize: "20px" }} /> 
               : <MinusCircleOutlined style={{ color: "#AAAAAA", fontSize: "20px" }} />
};

const PaymentExpandableRows = (props: Props) => {
  const { tabs, tabPanels, onSelect, defaultSelectedTab, id, paymentTypes, mode, upiDown, setUpdated, applePayment,isApplePay, interval, accountGid, getCurrentTab } = props;
  
  const [otherPayment, setOtherPayment] = useState(null);
  const [mobileView, setMobileView] = useState(false);
  const [checked, setChecked] = useState(null);
  const [cardChecked, setCardChecked] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
      const windowWidth = window.innerWidth;
      if (windowWidth < 480) {
          setMobileView(true);
      }
  }, []);

  const getPaymentBanks = () => {
    const tabPanelsIds = tabPanels?.map((item) => item?.id);
    const filterPaymentBankTabs = tabs?.filter((item) => bankPaymentMethods.includes(item) && tabPanelsIds.includes(item));
    const fixedOrder = ["ACH_LEGACY", "X_ACH", "ZIP_ACH", "RAPID_ACH"];
    // filter & sort according to fixed order
    const orderedResult = fixedOrder.filter(item => filterPaymentBankTabs.includes(item));
    return orderedResult;
  };

  const tabMap = new Map(tabPanels.map((t) => [t.id, t.children]));

  const tabIndexStore = (value) => {
    let methodKey = value;

    // If it's a number (bank collapse index), resolve actual payment method
    if (!isNaN(value)) {
      const bankTabs = getPaymentBanks();
      methodKey = bankTabs[value]; // get actual key like "ACH_LEGACY"
    }

    // Get label (fallback to methodKey if not found in helper)
    const label = paymentMethodsHelper[methodKey]?.key || methodKey;
    
    if(getCurrentTab) {
      getCurrentTab(label);
    };
    localStorage.setItem(`${id}-tab-name`, label);
  };


  return (
    <FlexContainer className={mobileView ? "w-100 p-3" : "w-100"} box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
      display="flow-root" backgroundColor="#fff" borderRadius="10px" marginTop="5%" marginBottom="5%"
    >
      <Img src={SWIREPAY_FULL_LOGO} style={{ marginBottom: '1rem', width: '10rem' }} />
      {tabs?.length > 0 && getPaymentBanks().length > 0 && (
        <DescriptionText className="mb-3" fontSize="17px">SELECT PAYMENT METHOD</DescriptionText>
      )}
      <Collapse className="mb-4 w-100" accordion activeKey={checked}
        onChange={(value) => { setChecked(value); setCardChecked(false); setOtherPayment(false); dispatch(setUpdateStatus(true)); tabIndexStore(value); }}
      >
        {tabs?.length > 0 && getPaymentBanks()?.map((item, indexKey) => (
          <Collapse.Panel 
            key={indexKey} 
            extra={!mobileView && getCheckedIcons(parseInt(checked) === indexKey)} 
            header={
              <>
                <Img src={paymentMethodsHelper[item]?.icon} style={{ marginBottom: '-5px' }} /> 
                <span className="ml-2" style={{ fontWeight: '600' }}>{paymentMethodsHelper[item]?.label}</span>
                <span className="ml-2">{paymentMethodsHelper[item]?.subText || null}</span>
              </>
            }
          >
            {tabMap.get(item)}
          </Collapse.Panel>
          ))}
      </Collapse>
      {tabs?.length > 0 && tabs?.filter((item) => item === 'CARD').length > 0 && (
        <DescriptionText className="mb-3" fontSize="17px">CARD</DescriptionText>
      )}
      <Collapse className="mb-4 w-100" accordion activeKey={cardChecked}
        onChange={(value) => { setCardChecked(value); setChecked(false); setOtherPayment(false); dispatch(setUpdateStatus(true)); tabIndexStore('CARD'); }}
      >
        {tabs?.length > 0 && tabs?.filter((item) => item === 'CARD')?.map((item, indexKey) => (
          <Collapse.Panel 
            key={indexKey} 
            extra={ !mobileView && (
            <div className="d-flex align-items-center gap-8">
              <Img src={VISA} /> 
              <Img src={MASTER} />
              <Img src={DISCOVER} />
              <Img src={AMEX} />
              {getCheckedIcons(cardChecked)}
            </div>
              )} 
            header={
              <>
                <Img src={paymentMethodsHelper[item]?.icon} style={{ marginBottom: '-5px' }} /> 
                <span className="ml-2" style={{ fontWeight: '600' }}>
                  {paymentMethodsHelper[item]?.label}
                </span>
              </>
            }
          >
            {tabMap.get(item)}
          </Collapse.Panel>
          ))}
      </Collapse>
      {tabs.length > 0 && (tabs.filter((item) => !omitOtherPayments.includes(item)).length > 0 || (isApplePay && applePayment)) && (
        <DescriptionText className="mb-3" fontSize="17px">More Options</DescriptionText>
      )}
      <FlexContainer className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "10px" }}>
          {tabs.length > 0 && tabs.filter((item) => !omitOtherPayments.includes(item)).map((item, index) => (
            <Button
              style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }} 
              type="ghost" className="mb-3" disabled={item === 'UPI' && upiDown}
              onClick={() => { setOtherPayment(item); setCardChecked(false); setChecked(false); dispatch(setUpdateStatus(true)); tabIndexStore(item); }}
            >
              <Img width="17px" src={paymentMethodsHelper[item]?.icon || INSTANT_PAYMENT_IMG} className="mr-2" /> {paymentMethodsHelper[item]?.label || item}
            </Button>
          ))}
          {isApplePay && applePayment && (
            <Button
              style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }} 
              type="ghost" className="mb-3"
              onClick={() => { setOtherPayment('APPLE_PAY_US'); setCardChecked(false); setChecked(false); tabIndexStore('APPLE_PAY_US'); dispatch(setUpdateStatus(true)); }}
            >
              <Img width="17px" src={paymentMethodsHelper['APPLE_PAY_US']?.icon} className="mr-2" /> {paymentMethodsHelper['APPLE_PAY_US']?.label}
            </Button>
          )}
          {otherPayment && (
            <div style={{ backgroundColor: '#f7f5f5', borderRadius: '10px' }} className='p-3 w-100 mb-2'>
              {tabMap.get(otherPayment)}
            </div>
          )}
      </FlexContainer>
    </FlexContainer>
  )
};

export default PaymentExpandableRows;
